type CityStateZipInput = {
  locationType?: "IN_PERSON" | "REMOTE" | null;
  city?: string | null;
  state?: string | null;
  zip?: string | null;
};

type GigListLocationInput = {
  locationType?: "IN_PERSON" | "REMOTE" | null;
  city?: string | null;
  state?: string | null;
  zip?: string | null;
  distanceMiles?: number | null;
};

type DistanceLabelInput = {
  distanceMiles?: number | null;
  zip?: string | null;
  comparisonZip?: string | null;
};

const normalizeZip = (value?: string | null): string | null => {
  const trimmed = value?.trim() ?? "";
  return trimmed.length > 0 ? trimmed : null;
};

export const formatCityStateZip = (value: CityStateZipInput, fallback = "Location TBD"): string => {
  if (value.locationType === "REMOTE") {
    return "Remote";
  }

  const city = value.city?.trim() ?? "";
  const state = value.state?.trim() ?? "";
  const zip = value.zip?.trim() ?? "";

  const cityState = [city, state].filter(Boolean).join(", ");
  if (cityState && zip) {
    return `${cityState} ${zip}`;
  }
  if (cityState) {
    return cityState;
  }
  if (zip) {
    return zip;
  }

  return fallback;
};

export const formatDistanceLabel = ({ distanceMiles, zip, comparisonZip }: DistanceLabelInput): string | null => {
  if (typeof distanceMiles !== "number") {
    return null;
  }

  const normalizedZip = normalizeZip(zip);
  const normalizedComparisonZip = normalizeZip(comparisonZip);
  if (normalizedZip && normalizedComparisonZip && normalizedZip === normalizedComparisonZip) {
    return "Same ZIP code";
  }

  return `${distanceMiles.toFixed(1)} miles away`;
};

export const formatGigListLocation = (
  value: GigListLocationInput,
  comparisonZip?: string | null,
  fallback = "Location TBD",
): string => {
  if (value.locationType === "REMOTE") {
    return "Remote";
  }

  const cityState = formatCityStateZip({ city: value.city, state: value.state, zip: value.zip }, fallback);
  const distanceLabel = formatDistanceLabel({
    distanceMiles: value.distanceMiles,
    zip: value.zip,
    comparisonZip,
  });
  if (distanceLabel) {
    return `${cityState} • ${distanceLabel}`;
  }
  return cityState;
};
